export const USER_DATA = [
  {
    titulo: 'Fecha de nacimiento',
    descripcion: '5/07/2019'
  },
  {
    titulo: 'Género',
    descripcion: 'Hombre'
  },
  {
    titulo: 'Correo electrónico UABC',
    descripcion: 'nombre.apellido@uabc.edu.mx'
  },
  {
    titulo: 'Correo alternativo',
    descripcion: 'nombre.apellido@gmail.com'
  },
  {
    titulo: 'Carrera',
    descripcion: 'Ingeniería en computación'
  },
  {
    titulo: 'Periodo de Ingreso',
    descripcion: '2015-1'
  },
  {
    titulo: 'Semestres cursados',
    descripcion: '9'
  }
];
